// extracted by mini-css-extract-plugin
export var container = "_1f-0";
export var disabled = "_1f-4";
export var fullWidth = "_1f-3";
export var lined = "_1f-1";
export var selected = "_1f-5";
export var tab = "_1f-2";